import Parse from 'parse';
export const commonLogoutFunction = () => {
  Parse.User.logOut();
        localStorage.removeItem('username');
        localStorage.removeItem('useremail');
        localStorage.removeItem('sessionToken');
        localStorage.removeItem('isLoggedin');
        localStorage.removeItem('ispicture_popup');
        window.location.href = "/";
};

export const commonVariable = 'common variable';


// WEBPACK FOOTER //
// ./src/common.js